import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserProgressContext from "../../userProgressContext";
import SoundManager from "../../services/SoundManager";
import GrizzyIcon from "../../static/images/characters/Grizzy.png";
import { totalLevel } from "../../constants/constants";

const Sidebar = ({ isOpen, toggleSidebar, initialGameProgressToggle }) => {
  const { audioMuted, progress, localProgress, setLocalProgress } =
    useContext(UserProgressContext);
  const [gameProgressToggleOpen, setGameProgressToggleOpen] = useState(
    initialGameProgressToggle
  );
  const navigate = useNavigate();

  const currentLevel =
    localProgress != null ? Math.trunc(parseFloat(localProgress)) : -1;

  const toggleGameProgressDropDown = () => {
    setGameProgressToggleOpen(!gameProgressToggleOpen);
  };

  const handleSidebarNavigation = (i) => {
    if (currentLevel !== i) {
      SoundManager.playSfx('game-retro-click');
      navigate("/level/" + i);
      setLocalProgress(parseInt(i) + 0.01);
    }
  };

  const levels =
    progress !== null
      ? [...Array(Math.min(parseInt(progress), totalLevel) + 1)].map((_, i) => i)
      : [];

  return (
    <div
      className={`relative h-full bg-cyber-bg/90 text-cyber-text border border-cyber-dim transform ${
        isOpen ? "translate-x-0" : "-translate-x-full"
      } h-full w-48 rounded-lg text-center min-[1024px]:translate-x-0 transition-transform duration-300 ease-in-out z-10`}
    >
      <div className="px-4 py-2 h-full overflow-auto">
        <h2
          className="inline-flex items-center text-xs sm:text-sm font-bold mb-4 tracking-widest uppercase text-cyber-faint hover:text-cyber-accent hover:cursor-pointer hover:scale-105 transform-all duration-100 ease-in"
          onClick={toggleGameProgressDropDown}
        >
          Game Progress{" "}
          <svg
            className={`w-4 h-4 ml-2 transform transition-transform duration-200 ${
              gameProgressToggleOpen ? "rotate-180" : "rotate-0"
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M19 9l-7 7-7-7"
            ></path>
          </svg>
        </h2>

        {gameProgressToggleOpen && progress !== null && (
          <div className="relative flex flex-col pl-2">
            {/* Vertical connector line behind the nodes */}
            {levels.length > 1 && (
              <div
                className="absolute w-0.5 bg-cyber-dim"
                style={{
                  left: "calc(0.5rem + 14px)",
                  top: "22px",
                  bottom: "22px",
                }}
              />
            )}

            {levels.map((i) => {
              const isActive = currentLevel === i;
              const isCompleted = progress !== null && i < progress;

              return (
                <button
                  key={i}
                  onClick={() => handleSidebarNavigation(i)}
                  className="relative flex items-center gap-2.5 py-2 w-full text-left group"
                >
                  {/* Node with optional ping ring */}
                  <div className="relative flex-shrink-0 w-7 h-7">
                    {isActive && (
                      <span className="absolute inset-0 rounded-full bg-cyber-accent/30 animate-ping" />
                    )}
                    <div
                      className={`relative z-10 w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold border-2 transition-all duration-200 overflow-hidden ${
                        isActive
                          ? "border-cyber-accent shadow-lg shadow-cyber-accent/50"
                          : isCompleted
                          ? "bg-cyber-panel border-cyber-dim group-hover:bg-cyber-muted group-hover:border-cyber-accent/70"
                          : "bg-cyber-deep border-cyber-dim"
                      }`}
                    >
                      {isActive ? (
                        <img
                          src={GrizzyIcon}
                          alt="Grizzy"
                          className="w-full h-full object-cover object-top"
                        />
                      ) : isCompleted ? (
                        <svg
                          className="w-3.5 h-3.5 text-green-400"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={3}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      ) : (
                        <span className="text-slate-400">{i}</span>
                      )}
                    </div>
                  </div>

                  {/* Label */}
                  <div className="flex flex-col leading-tight">
                    <span
                      className={`text-xs font-semibold tracking-widest uppercase transition-colors duration-200 ${
                        isActive
                          ? "text-cyber-accent"
                          : isCompleted
                          ? "text-cyber-sub group-hover:text-cyber-accent"
                          : "text-cyber-dim"
                      }`}
                    >
                      {isCompleted ? "DONE" : isActive ? "CURRENT" : "LOCKED"}
                    </span>
                    <span
                      className={`text-sm transition-colors duration-200 ${
                        isActive
                          ? "text-cyber-text font-bold"
                          : isCompleted
                          ? "text-cyber-faint group-hover:text-cyber-text"
                          : "text-cyber-sub"
                      }`}
                    >
                      Level {i}
                    </span>
                  </div>
                </button>
              );
            })}
          </div>
        )}

      </div>
    </div>
  );
};

export default Sidebar;
